import { FC} from "react";
import { FaExclamationCircle } from "react-icons/fa";

interface CarStatusProps {
 status : string,
 revertedDraft? : string
}

const CarStatus: FC<CarStatusProps> = ({
  status,
  revertedDraft
}) => {
  
  const isRevisionRequired = (revertedDraft === 'true') ? true : false;
  const OpenCarColor = status === "Closed" ? "#919191" :"#4A831E";
  const RevisionRequired = FaExclamationCircle  as React.FC;

  return (
    <div className="car-Starus">
      { isRevisionRequired &&  <div className="m-0" style={{color : "#C43131" }}> <RevisionRequired/> Revision Required</div>}
      { !isRevisionRequired &&  <div className="m-0" style={{color : OpenCarColor ? OpenCarColor : "" , fontWeight: '600'}}>{status}</div>}
    </div>
  );
};

export default CarStatus;
